<template>
  <div
    :id="accordionInnerId"
    class="accordion-collapse collapse accordion-border"
    :data-bs-parent="'#' + accordionOuterId"
  >
    <div class="p-3">
      <div class="form-check">
        <input
          class="form-check-input me-3"
          type="checkbox"
          v-model="isFishingActive"
          id="flexCheckFishing"
        />
        <img src="@/assets/svg/fishing.svg" class="icon mb-1 me-3" />
        <label class="form-check-label NKT-P2" for="flexCheckFishing"> Fishing </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input me-3"
          type="checkbox"
          v-model="isCargoActive"
          id="flexCheckCargo"
        />
        <img src="@/assets/svg/cargo.svg" class="icon mb-1 me-3" />
        <label class="form-check-label NKT-P2" for="flexCheckCargo"> Cargo </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input me-3"
          type="checkbox"
          v-model="isTankerActive"
          id="flexCheckTanker"
        />
        <img src="@/assets/svg/tanker.svg" class="icon mb-1 me-3" />
        <label class="form-check-label NKT-P2" for="flexCheckTanker"> Tanker </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input me-3"
          type="checkbox"
          v-model="isUnderwaterActive"
          id="flexCheckUnderwater"
        />
        <img src="@/assets/svg/underwater.svg" class="icon mb-1 me-3" />
        <label class="form-check-label NKT-P2" for="flexCheckUnderwater"> Underwater </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input me-3"
          type="checkbox"
          v-model="isDivingActive"
          id="flexCheckDiving"
        />
        <img src="@/assets/svg/diving.svg" class="icon mb-1 me-3" />
        <label class="form-check-label NKT-P2" for="flexCheckDiving"> Diving </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input me-3"
          type="checkbox"
          v-model="isPassengerActive"
          id="flexCheckPassenger"
        />
        <img src="@/assets/svg/passenger.svg" class="icon mb-1 me-3" />
        <label class="form-check-label NKT-P2" for="flexCheckPassenger"> Passenger </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input me-3"
          type="checkbox"
          v-model="isUnknownActive"
          id="flexCheckUnknown"
        />
        <img src="@/assets/svg/unknown.svg" class="icon mb-1 me-3" />
        <label class="form-check-label NKT-P2" for="flexCheckUnknown"> Unknown </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input me-3"
          type="checkbox"
          v-model="isOtherActive"
          id="flexCheckOther"
        />
        <img src="@/assets/svg/other.svg" class="icon mb-1 me-3" />
        <label class="form-check-label NKT-P2" for="flexCheckOther"> Other </label>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue'
import { useFilterStore } from '@/stores/HomeFilterStore'

const filterStore = useFilterStore()

defineProps({
  accordionInnerId: {
    type: String,
    required: true
  },
  accordionOuterId: {
    type: String,
    required: true
  }
})

const isFishingActive = computed({
  get() {
    return filterStore.isFishingActive
  },
  set() {
    filterStore.setFishing()
  }
})

const isCargoActive = computed({
  get() {
    return filterStore.isCargoActive
  },
  set() {
    filterStore.setCargo()
  }
})

const isTankerActive = computed({
  get() {
    return filterStore.isTankerActive
  },
  set() {
    filterStore.setTanker()
  }
})

const isUnderwaterActive = computed({
  get() {
    return filterStore.isUnderwaterActive
  },
  set() {
    filterStore.setUnderwater()
  }
})

const isDivingActive = computed({
  get() {
    return filterStore.isDivingActive
  },
  set() {
    filterStore.setDiving()
  }
})

const isPassengerActive = computed({
  get() {
    return filterStore.isPassengerActive
  },
  set() {
    filterStore.setPassenger()
  }
})

const isOtherActive = computed({
  get() {
    return filterStore.isOtherActive
  },
  set() {
    filterStore.setOther()
  }
})

const isUnknownActive = computed({
  get() {
    return filterStore.isUnknownActive
  },
  set() {
    filterStore.setUnknown()
  }
})
</script>
